import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '../services/session.service';

/**
 * Restricts a route to admins signed in through the FYES login form.
 * The backend enforces the same rule (fyesAdminRequired) — this only keeps
 * non-admins from landing on a page they could never load data for.
 */
export const adminGuard: CanActivateFn = () => {
    const session = inject(SessionService);
    const router = inject(Router);

    if (session.isLoggedIn() && session.isAdmin()) {
        return true;
    }

    router.navigate(['/']);
    return false;
};
